<template>
    <div style="width: 100%;">
        <div id="article">
            <div
                style="
                    width: 156px;
                    height: 156px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: var(--color-steel-100);
                    margin-right: var(--spacing-6);
                    margin-top: var(--spacing-6);
                "
            >
                <patternlib-spinner 
                    v-if="pictureSRC == null"
                    size="sm"
                    spin
                />

                <patternlib-image 
                    v-if="pictureSRC"
                    :src="pictureSRC"
                    height="100%"
                    width="100%"
                    object-fit = "scale-down"
                >
                </patternlib-image>

                <patternlib-icon
                    v-if="pictureSRC == ''"
                    size="64px"
                    icon-name = "HOME"
                ></patternlib-icon>
            </div>

            <div style="position: relative; flex-grow: 1;">
                <p><b>{{ name }}</b></p>
                <table>
                    <tr>
                        <td>{{ $t("myOrders.article.amount") }}</td>
                        <td>{{ amount }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("myOrders.article.articleStatus") }}</td>
                        <td>{{ $t(`myOrders.state.${articleStatus}`) }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("myOrders.article.shippingType") }}</td>
                        <td>{{ $t(`myOrders.article.shippingMethod.${shippingMethod}`) }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t("myOrders.article.packetStatus") }}</td>
                        <td>{{ $t(`myOrders.state.${packetStatus}`) }}</td>
                    </tr>
                </table>
                <p
                    style="
                        position: absolute;
                        top: 0px;
                        right: 0px;
                    "
                    id="price"
                ><b>{{ price }}</b></p>
            </div>
        </div>
        <div
            style="
                height: 0px;
                width: 100%;
                border-bottom-width: 1px;
                border-bottom-color: var(--color-steel-400);
                margin-top: var(--spacing-6);
            "
        ></div>
    </div>
</template>

<script>
export default {
    props: ["pictureSRC", "name", "amount", "articleStatus", "packetStatus", "shippingMethod", "price"],
    data: () => ({
        pictureSRC: "loading"
    }),
  
    components: {
    },
  
    computed: {
    },
  
    methods: {
    },

    created() {
        
    },
  
    mounted() {
    },
  };
</script>
  
<style lang="scss" scoped>
#article {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}

td {
    padding-right: var(--spacing-6);
}

@media only screen and (max-width: 770px) { 
    #article {
        flex-direction: column;
    }
    #price {
        top: auto !important;
        position: relative !important;
        float: right;
        margin-top: var(--spacing-4);
    }
}
  
</style>